var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/cloud",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(6.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3467,16.5088 C53.2047,16.5088 53.0657,16.5158 52.9247,16.5198 C51.1597,7.1148 42.9547,-0.0002 33.0917,-0.0002 C22.1527,-0.0002 13.2517,8.7528 12.9187,19.6758 C5.0497,20.3358 -0.9853,27.4888 0.1337,35.7958 C1.0877,42.8718 7.3637,47.9998 14.4627,47.9998 L52.9357,47.9998 C60.9707,47.9998 68.0207,42.0788 68.9017,34.0448 C69.9437,24.5468 62.5777,16.5088 53.3467,16.5088",
    id: "Fill-1",
    fillOpacity: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "22 55 61.001 55 61.001 25 22 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#D9D9D9",
    points: "25 52 58 52 58 28 25 28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9688,31 C43.9688,26.991 40.0548,23 33.4998,23 C26.9458,23 23.0318,26.991 23.0318,31 L43.9688,31 Z",
    id: "Fill-6",
    fill: "#C2AA30"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#785716",
    points: "23 34 44 34 44 31 23 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,39 L26,39 C24.343,39 23,37.657 23,36 L23,34 L44,34 L44,36 C44,37.657 42.657,39 41,39",
    id: "Fill-10",
    fill: "#C2AA30"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#135396",
    points: "0 29 37 29 37 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    points: "15 11 15 23 24 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,2 L32,2 L30,6 L35,6 L35,2 Z M27,2 L22,2 L20,6 L25,6 L27,2 Z M17,2 L12,2 L10,6 L15,6 L17,2 Z M5,6 L2,6 L2,2 L7,2 L5,6 Z",
    id: "Fill-25",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3f2b2cd68114d213c0aa1b895414c0f2.svg";
export { ForwardRef as ReactComponent };